import { useEffect, useRef } from "react";

/** Lightweight intersection-observer reveal hook.
 *  Adds `.in` class to elements with `.reveal` inside the ref subtree. */
export default function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current ?? document;
    const targets = root.querySelectorAll(".reveal");
    if (!targets.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
  }, []);

  return ref;
}
